import { SvgIcon } from '@mui/material';

const CCBYIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path d="M7.798 0.072c-4.282 0.109-7.727 3.62-7.727 7.928 0 4.376 3.552 7.928 7.928 7.928s7.928-3.552 7.928-7.928-3.552-7.928-7.928-7.928c-0.068 0-0.133-0.002-0.201 0zM7.791 1.435c0.070-0.002 0.138 0 0.209 0 3.624 0 6.566 2.941 6.566 6.566s-2.941 6.566-6.566 6.566c-3.624 0-6.566-2.941-6.566-6.566 0-3.553 2.83-6.454 6.356-6.566zM9.146 4.020c0 0.633-0.513 1.146-1.146 1.146s-1.146-0.513-1.146-1.146 0.513-1.146 1.146-1.146c0.633 0 1.146 0.513 1.146 1.146zM6.814 13.126h2.371v-3.81h0.717c0 0-0-2.723 0-3.152-0.001-0.113 0.010-0.338-0.154-0.502s-0.385-0.154-0.502-0.154c-0.117 0-2.376 0-2.493 0s-0.338-0.010-0.502 0.154-0.153 0.389-0.154 0.502c0 0.429 0 3.152 0 3.152h0.717v3.81z" />
  </SvgIcon>
);

export default CCBYIcon;
